export default "__VITE_ASSET__207ec511__"